export {
    useBorradoProgreso,
    BorradoProgresoProvider,
    BorradoProgresoContext
} from 'context/providers/BorradoProgresoProvider';

import { useBorradoProgreso } from 'context/providers/BorradoProgresoProvider';
export default useBorradoProgreso;
